import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class FeedbackPreset extends Model<Schemas['feedbackPresets'], Models> {
    /** Whether learners can choose this preset for content of the given type. */
    offeredFor(contentType: string): boolean {
        return !this.contentTypes || this.contentTypes.includes(contentType);
    }
}
